/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Template_Not_PublishableInputs */

const en_error_email_template_not_publishable = /** @type {(inputs: Error_Email_Template_Not_PublishableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email has errors to fix before it can be published.`)
};

/**
* | output |
* | --- |
* | "The email has errors to fix before it can be published." |
*
* @param {Error_Email_Template_Not_PublishableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_template_not_publishable = /** @type {((inputs?: Error_Email_Template_Not_PublishableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Template_Not_PublishableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_template_not_publishable(inputs)
});